import React from 'react';
import { useTheme } from '../utils/theme-context';

const DarkModeToggle = () => {
  const { isDark, toggleDarkMode } = useTheme();

  return (
    <button
      className="ml-2 px-3 py-1 rounded bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-gray-200 focus:outline-none hover:bg-gray-300 dark:hover:bg-gray-700 transition-colors duration-200"
      onClick={toggleDarkMode}
      aria-label="Toggle dark mode"
    >
      {isDark ? '🌙' : '☀️'}
    </button>
  );
};

export default DarkModeToggle; 